module.exports = __webpack_public_path__ + "static/kam-chauhan-social-media-136-87f1daefc49a6bc111b51c79d4c242b5.jpg";